import { Button, Paper } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import React, { ReactNode } from 'react';
import { LogService } from 'services/data-services/LogService';
import { container } from 'services/ioc/ioc';
import { ErrorBoundaryWrapper, Title } from './ErrorBoundaryStyles';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  logService: LogService;

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
    this.logService = container.get<LogService>(ServiceTypes.LogService);
  }

  static getDerivedStateFromError(error: any): State {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: React.ErrorInfo): void {
    this.logService.logError(
      { error, info: errorInfo },
      {
        function: 'ErrorBoundary@componentDidCatch',
      }
    );
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryWrapper>
          <Title>Unexpected error</Title>
          <Paper>
            <p>Incident details where logged. </p>
            <Button intent='primary' label='Reload' onClick={(): void => window.location.reload()} width='80px' />
          </Paper>
        </ErrorBoundaryWrapper>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
